import { Field as ChakraField, HStack } from '@chakra-ui/react'
import * as React from 'react'

import { Box } from './box'
import { Stack } from './stack'

export interface FieldProps extends Omit<ChakraField.RootProps, 'label'> {
  label?: React.ReactNode
  helperText?: React.ReactNode
  counter?: React.ReactNode
  errorText?: React.ReactNode
  optionalText?: React.ReactNode
}

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(
  function Field(props, ref) {
    const {
      label,
      children,
      helperText,
      counter,
      errorText,
      optionalText,
      ...rest
    } = props
    return (
      <ChakraField.Root ref={ref} {...rest}>
        <Stack gap="1" w="full">
          {label && (
            <FieldLabel fontWeight="normal" color="text.sub">
              {label}
              <ChakraField.RequiredIndicator fallback={optionalText} />
            </FieldLabel>
          )}
          {children}
        </Stack>
        {helperText && counter ? (
          <HStack w="100%" justify="space-between">
            {helperText && (
              <FieldHelperText fontSize="xs" color="gray.500">
                {helperText}
              </FieldHelperText>
            )}
            {counter && (
              <FieldHelperText fontSize="xs" color="gray.500">
                {counter}
              </FieldHelperText>
            )}
          </HStack>
        ) : helperText ? (
          <FieldHelperText fontSize="xs" color="gray.500">
            {helperText}
          </FieldHelperText>
        ) : counter ? (
          <Box w="100%" display="flex" justifyContent="space-between">
            {errorText && <FieldErrorText w="full">{errorText}</FieldErrorText>}
            <FieldHelperText
              fontSize="xs"
              color="gray.500"
              w="full"
              display="flex"
              justifyContent="end"
            >
              {counter}
            </FieldHelperText>
          </Box>
        ) : null}
        {/* counterとerrorTextを横並びで表示するためにcounterの場合は別途styleしている */}
        {errorText && !counter && <FieldErrorText>{errorText}</FieldErrorText>}
      </ChakraField.Root>
    )
  },
)

export const FieldRoot = ChakraField.Root

export const FieldLabel = ({
  children,
  fontWeight = 'semibold',
  fontSize = 'md',
  color = 'gray.600',
  ...props
}: ChakraField.LabelProps) => {
  return (
    <ChakraField.Label
      fontWeight={fontWeight}
      color={color}
      fontSize={fontSize}
      {...props}
    >
      {children}
    </ChakraField.Label>
  )
}

export const FieldHelperText = ChakraField.HelperText

export const FieldErrorText = ChakraField.ErrorText
